import { HeadContent, Link, Outlet, createRootRoute } from '@tanstack/react-router'
import { AppShell } from '@/components/app/app-shell'
import { buttonVariants } from '@/components/ui/button'

// Document-level only: <HeadContent /> renders each route's `head` (title, meta). No nav or footer here,
// since marketing, product and ops screens all share this root. Each layout provides its own skip link
// and a <main id="main">.
export const Route = createRootRoute({
  head: () => ({
    meta: [
      { title: 'Hedgehog' },
      {
        name: 'description',
        content:
          'We rebuild your WordPress site with the same design on a fast, secure platform. Free audit, preview before you pay, fixed price.',
      },
    ],
  }),
  component: () => (
    <>
      <HeadContent />
      <Outlet />
    </>
  ),
  notFoundComponent: () => (
    <AppShell>
      <div className="mx-auto flex max-w-md flex-col items-center gap-3 py-16 text-center">
        <h1 className="text-2xl font-semibold">Page not found</h1>
        <p className="text-muted-foreground">Check the address, or start from the home page.</p>
        <Link to="/" className={buttonVariants({ size: 'lg' })}>
          Go to the home page
        </Link>
      </div>
    </AppShell>
  ),
})
